import React from 'react';
import {ToastContainer} from 'react-toastify';
import AppRoute from './Routes';
import './index.css';
import {haandleJwtInLocalStorage} from './Components/utils/UserAuthHelper';
import {getParams} from './Components/utils';


const App = () => (
    <>
    {
        haandleJwtInLocalStorage(getParams(window.location.search))
    }
        <AppRoute />
        <ToastContainer />
    </>
);

export default App;